import React from 'react';
import {
  Box, Typography, Button, TextField, IconButton, Divider,
  FormControl, List, MenuItem, Select,
} from '@mui/material';
import {
  Star as StarIcon, ArrowForward as ArrowForwardIcon,
  Lock as LockIcon, ShoppingCart as ShoppingCartIcon,
} from '@mui/icons-material';
import FAQAccordion from '../../../FAQAccordion';
import ComparisonTable from '../../../ComparisonTable';
import TwoColumnComparisonTable from '../../../TwoColumnComparisonTable';
import FittableImage from '../../../FittableImage';
import CircularImageCropper from '../../../CircularImageCropper';
import ImageCropper from '../../../ImageCropper';
import Checklist from '../../../Checklist';
import CenteredVideoPlayer from '../../../CenteredVideoPlayer';
import ResizableButton from '../../../ResizableButton';
import InlineRowLayout from '../../../InlineRowLayout';
import ExtractedElementControls from '../../../ElementControls';
import { getPreset, getPresetFontFamilies } from '../../../../textStyle.js';
import { getListIcon } from '../../../../utils/offerListIcons';
import { ELEMENT_TYPES, LAYOUT_TYPES } from '../../../../utils/offerElementTypes';
import { LAYOUT_CONFIGS } from '../../../../utils/offerLayoutConfigs';
import { calculateVideoAspectRatio } from '../../../../utils/offerPreviewElement';

export const renderMiscElements = (element, ctx) => {
  const {
    isEditing, isEditingField, handleDoubleClick,
    isElementSelected, getSelectionStyles, ElementControls,
    editingElement, editingField, tempValue, setTempValue, textEditorRef,
    selectedElement, selectedElementContext, selectedSubElement,
    iconSelectorOpen, setIconSelectorOpen, isBrandsPage, paginationEnabled,
    currentPageIndex, pageSettings, forceRender, rightPanelOpen,
    setSelectedElement, setSelectedElementContext, setSelectedSubElement,
    setTabValue, setRightPanelOpen, setPages, setElements,
    setInsertAfterElementId, setPromptDialogTitle, setPromptDialogMessage,
    setPromptDialogValue, setPromptAction, setShowPromptDialog,
    startInlineEdit, saveInlineEdit, cancelInlineEdit, handleKeyPress,
    handleResizeStart, findAndUpdateLayout, moveElement, generateId,
    deleteElement, deleteElementFromZone, updateElement, applyHighlight,
    handleDragOver, handleDragLeave, handleDrop,
    getZoneHeightStyle, getHeightModeText, toggleZoneHeight, getHeightTooltip,
    getExpandIcon, selectedVariantKey, setSelectedVariantKey, targetZone,
    isInZone, layoutId, zoneId, elementIndex,
    renderInlineEditableElement,
  } = ctx;

  switch (element.type) {
case ELEMENT_TYPES.HTML:
  return (
    <Box
      data-element-id={element.id}
      sx={{
        position: 'relative',
        '&:hover .element-controls': { opacity: 1 },
        mb: 1,
        ...getSelectionStyles(element.id)
      }}
    >
      <ElementControls />
      {isEditingField('content') ? (
        <TextField
          value={tempValue}
          onChange={(e) => setTempValue(e.target.value)}
          onKeyDown={handleKeyPress}
          onBlur={saveInlineEdit}
          autoFocus
          variant="outlined"
          size="small"
          fullWidth
          multiline
          rows={4}
          placeholder="Enter HTML code"
          sx={{ mb: 1 }}
        />
      ) : (
        <Box
          sx={{
            backgroundColor: '#f5f5f5',
            p: 1,
            borderRadius: 1,
            cursor: 'pointer',
            '&:hover': { backgroundColor: '#e0e0e0' }
          }}
          onDoubleClick={() => handleDoubleClick('content', element.content)}
          title="Double-click to edit HTML • Hover for delete option"
        >
          <Typography variant="body2" color="text.secondary">
            💻 HTML Code {element.content ? `(${element.content.length} chars)` : '- Click to edit'}
          </Typography>
        </Box>
      )}
    </Box>
  );

case ELEMENT_TYPES.DIVIDER:
  return (
    <Box
      data-element-id={element.id}
      sx={{
        position: 'relative',
        '&:hover .element-controls': { opacity: 1 },
        mb: 0.5,
        ...getSelectionStyles(element.id)
      }}
    >
      <ElementControls />
      <Box
        sx={{
          height: '1px',
          backgroundColor: '#e0e0e0',
          margin: '4px 0',
          cursor: 'pointer',
          '&:hover': { backgroundColor: '#1976d2' }
        }}
        title="Divider line • Hover for delete option"
      />
    </Box>
  );

case ELEMENT_TYPES.CHECKLIST:
  return (
    <Box
      data-element-id={element.id}
      sx={{
        position: 'relative',
        '&:hover .element-controls': { opacity: 1 },
        mb: 0,
        ...getSelectionStyles(element.id)
      }}
    >
      <ElementControls />
      <Checklist title={element.title} items={element.items} />
    </Box>
  );
    default:
      return null;
  }
};
